import { useRef } from "react";
import { useIntersectionObserver } from "../../../common/CustomeHook/useIntersectionObserver";
import { cn } from "../../../lib/utils";

export default function AnimatedSection({
  children,
  className,
  delay = "delay-0",
  from = "bottom",
}) {
  const ref = useRef(null);
  const isIntersecting = useIntersectionObserver(ref, { threshold: 0.1 });

  const fromClasses = {
    bottom: "translate-y-8",
    top: "-translate-y-8",
    left: "-translate-x-8",
    right: "translate-x-8",
  };

  const toClasses = {
    bottom: "translate-y-0",
    top: "translate-y-0",
    left: "translate-x-0",
    right: "translate-x-0",
  };

  return (
    <div
      ref={ref}
      className={cn(
        "transition-[opacity,transform] duration-500 ease-out will-change-transform",
        isIntersecting
          ? `opacity-100 ${toClasses[from]}`
          : `opacity-0 ${fromClasses[from]}`,
        delay,
        className
      )}
    >
      {children}
    </div>
  );
}
